var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.price)?_c('div',{staticClass:"product-price",class:[
    _vm.size ? 'product-price--' + _vm.size : '',
    _vm.type ? 'product-price--' + _vm.type : '',
    { 'product-price--vertical': _vm.vertical }
  ]},[_c('span',{staticClass:"product-price__current",class:{ 'product-price__current--sale': _vm.isSale }},[_vm._v(_vm._s(_vm._f("CurrencyFormatter")(_vm.price))+" "+_vm._s(_vm.currency))]),(_vm.isSale)?_c('del',{staticClass:"product-price__old"},[_vm._v(_vm._s(_vm._f("CurrencyFormatter")(_vm.oldPrice))+" "+_vm._s(_vm.currency))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }